<div class="cookiebar">
    <span class="click" (click)="openPolicy.emit(true)">Cookie Policy</span>
</div>
